import { BASE_URL_API } from "../../configs";
import { GoDotFill } from "react-icons/go";
const BrandFooter = () => {

    const apiUrl = BASE_URL_API ?? ''

    const dafcLogo = apiUrl + '/images/brands/logo-dafc.png'

    const items = [
        { title: 'Rolex', image: apiUrl + '/images/brands/1.png' },
        { title: 'Cartier', image: apiUrl + '/images/brands/2.png' },
        { title: 'Messika', image: apiUrl + '/images/brands/5.png' },
        { title: 'Balmain', image: apiUrl + '/images/brands/6.png' },
        { title: 'Burberry', image: apiUrl + '/images/brands/7.png' },
        { title: 'CL', image: apiUrl + '/images/brands/9.png' },
        { title: 'Chole', image: apiUrl + '/images/brands/91.jpg' },
        { title: 'DG&GB', image: apiUrl + '/images/brands/10.png' },
        // { title: 'EF', image: apiUrl + '/images/brands/12.png' },
        { title: 'EA', image: apiUrl + '/images/brands/13.png' },
        { title: 'Franck Muller', image: apiUrl + '/images/brands/35.png' },
        { title: 'GR', image: apiUrl + '/images/brands/36.png' },
        { title: 'Jacqueline', image: apiUrl + '/images/brands/15.png' },
        // { title: 'Jimmy Choo', image: apiUrl + '/images/brands/16.png' },
        { title: 'MCM', image: apiUrl + '/images/brands/20.png' },
        { title: 'Montblanc', image: apiUrl + '/images/brands/23.png' },
        { title: 'Moschino', image: apiUrl + '/images/brands/38.png' },
        { title: 'Mo5ch1no Jeans', image: apiUrl + '/images/brands/39.png' },
        { title: 'Messyweekend', image: 'https://www.dafc.com.vn/wp-content/uploads/2024/11/GIFT-VOUCHER-1920-x-500-px-1-2048x405.png' },
        { title: 'MSGM', image: 'https://www.dafc.com.vn/wp-content/uploads/2024/08/msgm-logo-1024x819.png' },
        // { title: 'OR', image: apiUrl + '/images/brands/24.png' },
        // { title: 'Paul&Shark', image: apiUrl + '/images/brands/25.png' },
        { title: 'Ferragamo', image: apiUrl + '/images/brands/27.png' },
        { title: 'Santoni', image: apiUrl + '/images/brands/28.png' },
        { title: 'Seft-Portrait', image: apiUrl + '/images/brands/281.jpg' },
        { title: 'Stefano Ricci', image: apiUrl + '/images/brands/37.png' },
        { title: 'Tumi', image: apiUrl + '/images/brands/30.png' },
        { title: 'Versace Jeans Couture', image: apiUrl + '/images/brands/31.png' },
        { title: 'Versace', image: apiUrl + '/images/brands/32.png' },
        { title: 'APC', image: 'https://www.dafc.com.vn/wp-content/uploads/2025/11/APC.jpeg' },
        { title: 'Palm Angels', image:'https://www.dafc.com.vn/wp-content/uploads/2025/11/Palm-Angels-Logo.jpg' },
        // { title: 'Zimmermann', image: apiUrl + '/images/brands/33.png' },
    ];

    return (
        <>
            <div className="mt-10 px-4 py-4 font-main">
                <div className="justify-center mx-auto my-5 w-[150px] h-auto">
                    <img className="flex justify-center mx-auto my-5 w-[150px] h-auto" src={dafcLogo} alt="DAFC"
                         width={150} height={32}/>
                </div>
                <p className="font-normal text-[14px] leading-[1.6] text-justify">Established in 2005, DAFC has been the leading authority in luxury retail and brand building in Vietnam, dedicated to strategically introducing and sustainably developing the world’s most prestigious brands.</p>
                <div className="grid grid-cols-3 grid-rows-3 gap-4 pt-6 pb-5">
                    {items.map((item, index) => (
                        <div key={index}
                             className="relative bg-white flex items-center justify-center overflow-hidden rounded-sm aspect-[106/70]">
                            <img
                                className="w-auto h-auto max-w-[calc(100%-30px)] max-h-[50px]"
                                src={item.image}
                                alt={item.title}/>
                        </div>
                    ))}
                    <div className="relative bg-white flex items-center justify-center overflow-hidden rounded-sm aspect-[106/70] text-center">
                        <span className="flex flex-row text-xl text-black text-center"><GoDotFill /><GoDotFill /><GoDotFill /></span>
                    </div>
                </div>
                <div className="grid grid-cols-3 grid-rows-3 gap-4 pt-6 pb-5">
                </div>
            </div>
        </>
    )
}

export default BrandFooter;